const actions = {
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGOUT: 'LOGOUT',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  REGISTER_REQUEST: 'REGISTER_REQUEST',
  REGISTER_SUCCESS: 'REGISTER_SUCCESS',
  REGISTER_ERROR: 'REGISTER_ERROR',

  REQUEST_PASSWORD_RESET: 'REQUEST_PASSWORD_RESET',
  REQUEST_PASSWORD_RESET_SUCCESS: 'REQUEST_PASSWORD_RESET_SUCCESS',
  REQUEST_PASSWORD_RESET_FAILED: 'REQUEST_PASSWORD_RESET_FAILED',
  RESET_PASSWORD_RESET_DATA: 'RESET_PASSWORD_RESET_DATA',

  REQUEST_CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  REQUEST_CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
  REQUEST_CHANGE_PASSWORD_FAILED: 'CHANGE_PASSWORD_FAILED',
  RESET_CHANGE_PASSWORD_REQUEST_DATA: 'RESET_CHANGE_PASSWORD_REQUEST_DATA',

  GET_VERIFY_ACTIVATION: "GET_VERIFY_ACTIVATION",
  GET_VERIFY_ACTIVATION_SUCCESS: "GET_VERIFY_ACTIVATION_SUCCESS",
  GET_VERIFY_ACTIVATION_FAILED: "GET_VERIFY_ACTIVATION_FAILED",
  DO_SET_PASSWORD: "DO_SET_PASSWORD",
  DO_SET_PASSWORD_SUCCESS: "DO_SET_PASSWORD_SUCCESS",
  DO_SET_PASSWORD_FAILED: "DO_SET_PASSWORD_FAILED",

  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),
  login: payload => ({
    type: actions.LOGIN_REQUEST,
    payload
  }),
  logout: () => ({
    type: actions.LOGOUT
  }),
  register: payload => ({
    type: actions.REGISTER_REQUEST,
    payload
  }),

  requestPasswordReset: payload => ({
    type: actions.REQUEST_PASSWORD_RESET,
    payload
  }),
  requestPasswordResetSuccess: response => ({
    type: actions.REQUEST_PASSWORD_RESET_SUCCESS,
    payload: response
  }),
  requestPasswordResetFailed: response => ({
    type: actions.REQUEST_PASSWORD_RESET_FAILED,
    payload: response
  }),
  resetPasswordResetData: () => ({
    type: actions.RESET_PASSWORD_RESET_DATA
  }),

  changePasswordRequest: payload => ({
    type: actions.REQUEST_CHANGE_PASSWORD,
    payload
  }),
  changePasswordRequestSuccess: response => ({
    type: actions.REQUEST_CHANGE_PASSWORD_SUCCESS,
    payload: response
  }),
  changePasswordRequestFailed: response => ({
    type: actions.REQUEST_CHANGE_PASSWORD_FAILED,
    payload: response
  }),
  resetChangePasswordRequestData: () => ({
    type: actions.RESET_CHANGE_PASSWORD_REQUEST_DATA
  }),

  getVerifyActivation: payload => ({
    type: actions.GET_VERIFY_ACTIVATION,
    payload: payload
  }),
  getVerifyActivationSuccess: response => ({
    type: actions.GET_VERIFY_ACTIVATION_SUCCESS,
    payload: response
  }),
  getVerifyActivationFailed: response => ({
    type: actions.GET_VERIFY_ACTIVATION_FAILED,
    payload: response
  }),
  setPassword: response => ({
    type: actions.DO_SET_PASSWORD,
    payload: response
  }),
  setPasswordSuccess: response => ({
    type: actions.DO_SET_PASSWORD_SUCCESS,
    payload: response
  }),
  setPasswordFailed: response => ({
    type: actions.DO_SET_PASSWORD_FAILED,
    payload: response
  })
};
export default actions;



// WEBPACK FOOTER //
// ./src/redux/auth/actions.js